import _defineProperty from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/createClass.js";

var _logLevelToStringConv, _consoleMethodConvert;

var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
  LogLevel[LogLevel["INFO"] = 1] = "INFO";
  LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
  LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})(LogLevel || (LogLevel = {}));

var Logger = /*#__PURE__*/function () {
  function Logger(name) {
    _classCallCheck(this, Logger);

    this.logLevel = LogLevel.INFO;
    this.name = name; // Keep track of the logger instances to update them from global
    // logging methods.

    instances.push(this);
  }

  _createClass(Logger, [{
    key: "getLogLevel",
    value: function getLogLevel() {
      return this.logLevel;
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(logLevel) {
      if (typeof logLevel === 'string') {
        this.logLevel = logLevelStringConverter[logLevel];
        return;
      }

      this.logLevel = logLevel;
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.log.apply(this, [LogLevel.DEBUG].concat(args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.log.apply(this, [LogLevel.INFO].concat(args));
    }
  }, {
    key: "warning",
    value: function warning() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.log.apply(this, [LogLevel.WARNING].concat(args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      this.log.apply(this, [LogLevel.ERROR].concat(args));
    }
  }, {
    key: "log",
    value: function log(logLevel) {
      var _console;

      if (logLevel < this.logLevel) return;
      var now = new Date().toISOString();
      var method = consoleMethodConverter[logLevel];
      var format = this.logLevel >= LogLevel.INFO ? "[".concat(now, "] [").concat(this.name, "]") : "[".concat(now, "] [").concat(this.name, "] [").concat(logLevelToStringConverter[logLevel], "]"); // eslint-disable-next-line no-console

      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      (_console = console)[method].apply(_console, [format].concat(args));
    }
  }]);

  return Logger;
}();

function setLogLevel(logLevel) {
  instances.forEach(function (instance) {
    return instance.setLogLevel(logLevel);
  });
}
/**
 * A container for all logger instances.
 */


var instances = [];
var logLevelStringConverter = {
  debug: LogLevel.DEBUG,
  info: LogLevel.INFO,
  warning: LogLevel.WARNING,
  error: LogLevel.ERROR
};
var logLevelToStringConverter = (_logLevelToStringConv = {}, _defineProperty(_logLevelToStringConv, LogLevel.DEBUG, 'debug'), _defineProperty(_logLevelToStringConv, LogLevel.INFO, 'info'), _defineProperty(_logLevelToStringConv, LogLevel.WARNING, 'warning'), _defineProperty(_logLevelToStringConv, LogLevel.ERROR, 'error'), _logLevelToStringConv);
var consoleMethodConverter = (_consoleMethodConvert = {}, _defineProperty(_consoleMethodConvert, LogLevel.DEBUG, 'log'), _defineProperty(_consoleMethodConvert, LogLevel.INFO, 'info'), _defineProperty(_consoleMethodConvert, LogLevel.WARNING, 'warn'), _defineProperty(_consoleMethodConvert, LogLevel.ERROR, 'error'), _consoleMethodConvert);
export { LogLevel, Logger, setLogLevel };